import Vue from 'vue';
import Category from './Category';
import Landingpage from './Landingpage';
import Suggestion from './Suggestion';
import Vendor from './Vendor';
import TopQueries from './TopQueries';
import Promotion from './Promotion';
import aboveSmartSuggestBlocks from './AboveSmartSuggestBlocks';
import belowSmartSuggestBlocks from './BelowSmartSuggestBlocks';
import { SmartSuggestV4 } from '../../../../declarations/request';

export const availableSmartSuggestBlocks = {
    promotion: 'smart-suggest-promotion',
    topQueries: 'smart-suggest-top-queries',
    landingpage: 'smart-suggest-landingpage',
    textSuggestions: 'smart-suggest-suggestion',
    categories: 'smart-suggest-category',
    vendors: 'smart-suggest-vendor',
};
export type AvailableSmartSuggestBlock = keyof typeof availableSmartSuggestBlocks;

export default Vue.component('smart-suggest-blocks', {
    template: `
    <div class="fl-w-100 fl-as-smart-suggest-blocks-container">
        <fl-above-smart-suggest-blocks />
        <component
            v-for="blockName in suggestBlockOrder"
            :key="blockName"
            :is="availableBlocks[blockName]"
            v-bind="{[blockName]: $data[blockName]}"
        />
        <fl-below-smart-suggest-blocks />
    </div>
    `,
    data(): Record<string, any> {
        return {
            topQueries: [],
            textSuggestions: [],
            landingpage: null,
            categories: [],
            vendors: [],
            promotion: null,
            availableBlocks: availableSmartSuggestBlocks,
        };
    },
    mounted(): void {
        this.requestService.onResultChangeWithFallback((result: SmartSuggestV4.Response) => {
            this.$data.textSuggestions = result.textSuggestions;
            this.$data.landingpage = result.landingpage;
            this.$data.categories = result.attributeSuggestions?.cat || [];
            this.$data.vendors = result.attributeSuggestions?.vendor || [];
            this.$data.topQueries = result.topQueries;
            this.$data.promotion = result.promotion;
        });
    },
    inject: ['config', 'assets', 'requestService'],
    components: {
        AboveSmartSuggestBlocks: aboveSmartSuggestBlocks,
        BelowSmartSuggestBlocks: belowSmartSuggestBlocks,
        Category,
        Landingpage,
        Suggestion,
        Vendor,
        TopQueries,
        Promotion,
    },
    computed: {
        suggestBlockOrder(): AvailableSmartSuggestBlock[] {
            // Can't use Array.from(new Set(…)), because Magento 1 implements a wrong polyfill for it
            return this.config.assistedSuggest.config.suggestBlockOrder.filter(
                (value: AvailableSmartSuggestBlock, index: number) =>
                    this.config.assistedSuggest.config.suggestBlockOrder.indexOf(value) === index
            );
        },
    },
});
